import React, { Fragment } from "react";
import PublicHeader from "views/components/headers/public-header/PublicHeader";
import PublicSideBar from "./components/PublicSideBar";

interface IProps {
  readonly children: React.ReactElement;
  readonly header?: boolean;
}

const PublicRoute: React.FC<IProps> = ({ children, header = true }) => {
  return (
    <Fragment>
      {header && (
        <div className="wrapper">
          <PublicHeader />
          <PublicSideBar />
        </div>
      )}
      {children}
    </Fragment>
  );
};

export default PublicRoute;
